import FormControlInput from './form-control-input'

export default {

    props: {
        placeholder: {
            type: String,
            default: '',
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [ String, Number ],
            default: '',
        },
    },

    mixins: [
        FormControlInput,
    ],
}
